import "@unocss/reset/tailwind.css";
import init from "@unocss/runtime";
import { presetWind3 } from "@unocss/preset-wind3";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

await init({
  defaults: {
    presets: [presetWind3()],
  },
});

createApp(App).use(router).mount("#app");

import.meta.hot.accept();
